import { render, staticRenderFns } from "./UserEdit.vue?vue&type=template&id=c9be042a&scoped=true"
import script from "./UserEdit.vue?vue&type=script&lang=ts"
export * from "./UserEdit.vue?vue&type=script&lang=ts"
import style0 from "./UserEdit.vue?vue&type=style&index=0&id=c9be042a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9be042a",
  null
  
)

/* custom blocks */
import block0 from "./UserEdit.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports